/** @format */

import { DEFAULT_FILTERS } from '@/@ducks/listing/constants';
import { ListingFilters } from '@/@ducks/listing/types';
import { objectDeepDiff } from '@/utils/helpers/objectDeepDiff';

export const getFilterCount = (filters: ListingFilters) => {
  let total = 0;

  const result = objectDeepDiff(filters, DEFAULT_FILTERS) as any;

  for (const key in result) {
    if (Array.isArray(result[key])) {
      if (key !== 'areas') {
        // Do not consider areas as an active filter
        total += result[key].length;
      }
    }

    if (typeof result[key] === 'object' && result[key] !== null && !Array.isArray(result[key])) {
      if (key === 'monthlyPrice') {
        // Do not add both min and max values changes, keep as a single change
        total += 1;
      } else {
        total += Object.keys(result[key]).length;
      }

      if (key === 'propertyType') {
        if (result[key].colivingBuilding && result[key].singleRoom) {
          // NOTE: PropertyTypeFilter handleChange function is toggling both values (singleRoom and colivingBuilding), so we should count it as a single change
          total -= 1;
        }
      }
    }

    if (typeof result[key] === 'string') {
      if (key !== 'orderBy') {
        // Do not consider orderBy as an active filter
        total += 1;
      }
    }
  }

  return total;
};
